// Light / Dark theme (as v2.0.41's body.dark-theme): a per-device choice of Light, Dark or Automatic (follow the
// device setting). Kept in this browser only; a missing or blocked storage simply means Light.
export type ThemeChoice = "light" | "dark" | "auto";
const KEY = "falcon.theme";
export function themeChoice(): ThemeChoice {
  try { const v = localStorage.getItem(KEY); return v === "dark" || v === "auto" ? v : "light"; } catch { return "light"; }
}
const media = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
export function applyTheme(choice = themeChoice()): void {
  const dark = choice === "dark" || (choice === "auto" && !!media?.matches);
  document.body.classList.toggle("dark-theme", dark);
  document.documentElement.style.colorScheme = dark ? "dark" : "light";
}
export function setTheme(choice: ThemeChoice): void {
  try { localStorage.setItem(KEY, choice); } catch { /* this browser won't remember it */ }
  applyTheme(choice);
}
media?.addEventListener?.("change", () => applyTheme());
